export const INTEGRATIONS = {
    DISABLED: 'DISABLED',
    GEOCOMPLY_DESKTOP: 'GEOCOMPLY_DESKTOP',
    GEOCOMPLY_OOBEE: 'GEOCOMPLY_OOBEE',
    GEOCOMPLY_NATIVE: 'GEOCOMPLY_NATIVE',
    GEOCOMPLY_SOLUS: 'GEOCOMPLY_SOLUS'
};

export const GEOLOCATION_REASON = {
    UNDEFINED: 'UNDEFINED',
    INITIAL_CHECK: 'INITIAL_CHECK',
    INTERVAL_CHECK: 'INTERVAL_CHECK',
    IP_CHANGE_CHECK: 'IP_CHANGE_CHECK',
    RECONNECT_CHECK: 'RECONNECT_CHECK',
    ACL_RULE_FAILURE_CHECK: 'ACL_RULE_FAILURE_CHECK',
    SCHEDULE_RETRY: 'SCHEDULE_RETRY',
    FOREGROUND_CHECK: 'FOREGROUND_CHECK'
};
